import React from "react"
import { Link } from "gatsby"
import Logo from "./svgComponent/Logo"

const Layout = props => {
  const { children } = props
  const [toggleNav, setToggleNav] = React.useState(false)
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div className="site-head-container">
          <a
            className="nav-burger"
            href={`#`}
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div
              className="hamburger hamburger--collapse"
              aria-label="Menu"
              role="button"
              aria-controls="navigation"
            >
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </a>
          <nav id="swup" class="site-head-left">
            <ul className="nav" role="menu">
              <li className="nav-home nav-current" role="menuitem">
                <Link to={`/`}>Home</Link>
              </li>
              <li className="nav-about" role="menuitem">
                <Link to={`/#projects`}>Projects</Link>
              </li>
            </ul>
          </nav>
          <div className="site-head-center">
            <Link className="site-head-logo" style={{display: 'block', height:"20hv"}} to={`/`}>
              <Logo />
            </Link>
          </div>
          <div className="site-head-right">
            <div className="">
              <Link
                className="resume-button"
                style={{
                  border: "2px solid",
                  borderRadius: "8px",
                  opacity: "1",
                  color: "#fff",
                  padding: "12px 24px",
                }}
                to={`/resume`}
                title="resume"
                target="_blank"
                rel="noopener noreferrer"
              >
                Resume
              </Link>
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">
        <div id="swup" className="transition-fade">
          {children}
        </div>
      </main>
      <footer className="site-foot">
        &copy; {new Date().getFullYear()}{" "}
        <Link to={`/`}>
          <Logo />
        </Link>{" "}
        &mdash; Built with{" "}
        <a
          href="https://gatsbyjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Gatsby
        </a>
      </footer>
    </div>
  )
}

export default Layout
